module.exports = __webpack_public_path__ + "static/media/mtn-wallet.bd7de31e.svg";